import type { TableColumnType } from 'components/editor/grid/reduxStore/table.types';
import { ColumnTypeIdentifier } from 'components/editor/grid/reduxStore/table.types';
import { MIN_COLUMN_WIDTH } from './defaultData.tsx';

const isHandlerColumn = (column: TableColumnType): boolean => column.columnType === ColumnTypeIdentifier.HANDLER;

/**
 * Scales every non-HANDLER column's width by the same ratio so the columns keep
 * their relative proportions while summing to targetTotalWidth.
 */
export function redistributeColumnWidthsProportionally(columns: TableColumnType[], targetTotalWidth: number): TableColumnType[] {
  const previousTotalWidth = columns.filter((column) => !isHandlerColumn(column)).reduce((sum, column) => sum + (column.width ?? 0), 0);
  const ratio = previousTotalWidth > 0 ? targetTotalWidth / previousTotalWidth : 1;
  const resizableColumnCount = columns.filter((column) => !isHandlerColumn(column)).length;

  let allocatedWidth = 0;
  let resizableIndex = 0;
  return columns.map((column) => {
    if (isHandlerColumn(column)) return { ...column };

    resizableIndex++;
    const isLast = resizableIndex === resizableColumnCount;
    if (isLast) {
      return { ...column, width: Math.max(MIN_COLUMN_WIDTH, targetTotalWidth - allocatedWidth) };
    }

    const newWidth = Math.max(MIN_COLUMN_WIDTH, Math.round((column.width ?? MIN_COLUMN_WIDTH) * ratio));
    allocatedWidth += newWidth;
    return { ...column, width: newWidth };
  });
}
